import { render, staticRenderFns } from "./AddNoteForm.vue?vue&type=template&id=320d3e4c&"
import script from "./AddNoteForm.vue?vue&type=script&lang=js&"
export * from "./AddNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports